import * as firebase from 'firebase';

class AclConst {
  static ADMIN = 'admin';
  static AMP = 'amp';
  static DASHBOARD = 'dashboard';
  static CROSS_CHANNEL = 'cross_channel';
  static POI = 'poi';
  static CRM_ONBOARDING = 'crm_onboarding';
  static PARTNER_GRAPESHOT = 'partner_grapeshot';
  static HOUSEHOLDING = 'householding';
  static TRUEREACH = 'truereach';
  static GRAPH_EXPANSION = 'graph_expansion';
}

const aclRoutes = {
  [AclConst.ADMIN]: ['/admin'],
  [AclConst.AMP]: ['/amp'],
  [AclConst.DASHBOARD]: ['/dash'],
  [AclConst.POI]: ['/poi'],
}

class Auth {

  static isAdmin() {
    const { currentUser } = firebase.auth();
    return currentUser && currentUser.emailVerified && currentUser.isAdmin;
  }

  static routeToRequiredAcl(route) {
    let foundAcl = null;
    Object.keys(aclRoutes).some((aclKey, i, arr) => {
      aclRoutes[aclKey].some((aclRoute, i, arr) => {
        if (route.indexOf(aclRoute) === 0) {
          foundAcl = aclKey;
          return true;
        }
        return false;
      });
      if (foundAcl) {
        return true;
      }
      return false;
    });
    return foundAcl;
  }

  static getDefaultAcl() {
    let isAdmin = Auth.isAdmin();

    return {
      [AclConst.ADMIN]: isAdmin,
      [AclConst.AMP]: isAdmin,
      [AclConst.DASHBOARD]: isAdmin,
      [AclConst.ADMIN]: isAdmin,
      [AclConst.CROSS_CHANNEL]: false,
      [AclConst.POI]: isAdmin,
      [AclConst.CRM_ONBOARDING]: false,
      [AclConst.PARTNER_GRAPESHOT]: false,
      [AclConst.HOUSEHOLDING]: isAdmin,
      [AclConst.TRUEREACH]: false,
      [AclConst.GRAPH_EXPANSION]: false,
    }
  }

  static applyUserAcl(acl) {
    return Object.assign({}, Auth.getDefaultAcl(), acl);
  }
}

export {Auth as default, AclConst};



// WEBPACK FOOTER //
// ./src/util/auth.js